<template>
    <v-container>
        <v-container class="toolbar__container">
            <v-toolbar-title>{{ $t('operation.gridStatusTitle') }}</v-toolbar-title>
          <v-form>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idEmpresaSelected"
                  :items="empresas"
                  item-text="razao_social"
                  item-value="id_empresa"
                  clearable
                  :label="$tc('company.self', 1)"
                  @change="empresasSelectChanged"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idLinhaSelected"
                  :items="linhasSelect"
                  item-text="nome_linha"
                  item-value="id_linha"
                  clearable
                  :label="$tc('line.self', 1)"
                  @change="linhasSelectChanged"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idVeiculoSelected"
                  :items="veiculosSelect"
                  item-text="cod_veiculo"
                  item-value="id_veiculo"
                  clearable
                  :label="$tc('vehicle.self', 1)"
                ></v-autocomplete>
              </v-col>
              <v-row>
                <v-col cols="12" sm="10" md="4" style="min-width: fit-content; margin-left: 5px;">
                  <v-datetime-picker
                    :label="$t('operation.lastPositionDate')"
                    v-model="dtiniciobase"
                    :time-picker-props="timeProps"
                    :text-field-props="textFieldProps"
                    time-format="HH:mm:ss"
                    date-format="dd/MM/yyyy"
                    :clear-text="$t('datetime.close')"
                    ref="inputDtInicioBase"
                    :rules="[dtiniciobaseRules]"
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock</v-icon>
                    </template>
                  </v-datetime-picker>
                </v-col>

                <!-- <v-col cols="12" sm="1" md="1"></v-col> -->

                <v-col cols="1" sm="1" md="1" style="min-width: fit-content;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        fab
                        color="primary darken-1"
                        class="white--text"
                        v-bind="attrs"
                        v-on="on"
                        @click="populaGrid"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('operation.search') }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        fab
                        color="primary darken-1"
                        class="white--text"
                        v-bind="attrs"
                        v-on="on"
                        @click="limparFiltrosGridStatus"
                        style="margin-left: 10px"
                      >
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('operation.newConsult') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-row>
          </v-form>
        </v-container>

        <div id="tablecontainer">
        <merus-data-table
            :headers="headersGridStatusWithProperties"
            :items="itensGridStatusFiltered"
            @update:displayedItems="displayedItemsForExport = $event"
            :loading="loadinggridstatus"
            :loading-text="$t('system.messages.loading')"
            sort-by="cod_veiculo"
            dense
            class="elevation-7"
            locale="pt"
            style="border-radius: 10px; margin-top: 15px;"
            :options="{ itemsPerPage: 10 }"
        

 cod-tabela="RELGRIDSTATUS__GRID_STATUS_WITH_PROPERTIES" @update:headers="headersGridStatusWithProperties = $event">
            <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('operation.gridStatusTitle')"
                :token="token"
                :items="displayedItemsForExport !== null ? displayedItemsForExport : itensGridStatusFiltered"
                csv-title="gridstatus"
                :csv-headers="headersGridStatus"
                :pdf-title="$t('operation.gridStatusTitle')"
                :pdf-headers="headersGridStatus"
                pdf-filename="gridstatusvalgps"
                hide-search
            />
            </template>
        </merus-data-table>
        </div>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import DateUtils from "../utils/dateutils";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
    headersGridStatus: [],
    headersGridStatusWithProperties: [],
        user: null,
        token: null,
        displayedItemsForExport: null,
        empresas: [],
        linhas: [],
        linhasSelect: [],
        veiculos: [],
        veiculosSelect: [],
        idEmpresaSelected: null,
        idLinhaSelected: null,
        idVeiculoSelected: null,
        timeProps: {
            useSeconds: true,
        },
        dtiniciobase: null,
        itensGridStatus: [],
        loadinggridstatus: false,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    computed: {
        textFieldProps() {
            return {
            prependInnerIcon: "mdi-calendar",
            rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            };
        },
        itensGridStatusFiltered() {
            let select = this.itensGridStatus;

            if (this.idEmpresaSelected) {
                select = select.filter((v) => v.id_empresa == this.idEmpresaSelected);
            }

            if (this.idLinhaSelected) {
                select = select.filter((v) => v.id_linha == this.idLinhaSelected);
            }

            if (this.idVeiculoSelected) {
                select = select.filter((v) => v.id_veiculo == this.idVeiculoSelected);
            }

            return select;
        }
    },
    methods: {

        initialize() {
            this.populaEmpresas();
            this.populaLinhas();
            this.populaVeiculos();
            this.dtiniciobase = new Date();
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data;
                    this.populaLinhasSelect();
                },
            })
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                onSuccess: (response) => {
                    this.veiculos = response.data;
                    this.populaVeiculosSelect();
                },
            })
        },
        populaGrid() {
            this.loadinggridstatus = true;
            const date = DateUtils.getDateSQLFormatted(this.dtiniciobase);

            apiController.request(apiController.endpoints.getStatusallveiculospordata, {
                params: { dt: date },
                onSuccess: (response) => {
                    this.itensGridStatus = response.data;
                    this.loadinggridstatus = false;
                },
                onError: () => {
                    this.loadinggridstatus = false;
                },
            });
        },
        populaLinhasSelect() {
            let select = this.linhas;

            if (this.idEmpresaSelected) {
                select = select.filter((l) => l.id_empresa == this.idEmpresaSelected);
            }

            this.linhasSelect = select;
        },
        populaVeiculosSelect() {
            let select = this.veiculos;

            if (this.idEmpresaSelected) {
                select = select.filter((v) => v.id_empresa == this.idEmpresaSelected);
            }

            if (this.idLinhaSelected) {
                select = select.filter((v) => v.id_linha == this.idLinhaSelected);
            }

            this.veiculosSelect = select;
        },
        dtiniciobaseRules() {
            if (this.dtiniciobase > new Date()) {
                return this.$t('rules.inicialBiggerThanFinalDate');
            } else {
                return true;
            }
        },
        limparFiltrosGridStatus() {
            this.dtiniciobase = new Date();
            this.idEmpresaSelected = null;
            this.idLinhaSelected = null;
            this.idVeiculoSelected = null;
            this.itensGridStatus = [];
            this.populaLinhasSelect();
            this.populaVeiculosSelect();
        },
        empresasSelectChanged() {
            this.populaLinhasSelect();
            this.populaVeiculosSelect();
        },
        linhasSelectChanged() {
            this.populaVeiculosSelect();
        }
    }
}
</script>

<style>
    
</style>